import { Grid, Stack } from '@mui/material';
import { useEffect } from 'react';
import { useApi } from '../api/Api';
import { RequestSnackbar, useRequest } from '../api/Request';
import LoadMoreButton from '../bts/components/LoadMoreButton';
import { PlaylistResponse } from '../database/videos';
import LoadingPage from '../loading/LoadingPage';
import MediaItem from '../music/MediaItem';

export interface VideoTabProps {
    mediaType: string;
}
const VideoTab: React.FC<VideoTabProps> = ({ mediaType }) => {
    const api = useApi();
    const playlistRequest = useRequest<PlaylistResponse>();

    const onLoadMore = () => {
        playlistRequest.onStart();
        api.getYouTubePlaylistByType(mediaType, playlistRequest.data?.nextPageToken || '')
            .then((resp) => {
                playlistRequest.onSuccess({
                    ...resp.data,
                    items: [...(playlistRequest.data?.items || []), ...resp.data.items], // Append new items
                });
            })
            .catch((err) => {
                console.error('getYouTubePlaylistByType: ', err);
                playlistRequest.onFailure(err);
            });
    };

    useEffect(() => {
        if (!playlistRequest.isSent()) {
            playlistRequest.onStart();
            api.getYouTubePlaylistByType(mediaType, '')
                .then((response) => {
                    playlistRequest.onSuccess(response.data);
                })
                .catch((err) => {
                    console.error(err);
                    playlistRequest.onFailure(err);
                });
        }
    }, [api, playlistRequest, mediaType]);

    if (!playlistRequest.isSent() || playlistRequest.isLoading()) {
        return <LoadingPage />;
    }

    if (!playlistRequest.data) {
        return (
            <Stack>
                <RequestSnackbar request={playlistRequest} />
            </Stack>
        );
    }

    return (
        <>
            <Grid container justifyContent='center'>
                {playlistRequest.data.items.map((playlistItem) => (
                    <MediaItem playlist={playlistItem} key={playlistItem.id} />
                ))}
            </Grid>
            <LoadMoreButton
                request={playlistRequest}
                startKey={playlistRequest.data.nextPageToken || ''}
                onLoadMore={onLoadMore}
            />
        </>
    );
};

export default VideoTab;
